// Theme engine — Light / Dark / System, persisted in localStorage.
// Ported from design/spec/shell.js `applyTheme`, with one change agreed in
// the handoff: React standardizes on the `.dark` class (shadcn convention)
// instead of the prototypes' html[data-theme="dark"].

const KEY = "tuw-theme"

export function getTheme() {
  try {
    return localStorage.getItem(KEY) || "system"
  } catch (e) {
    return "system"
  }
}

export function applyTheme(mode) {
  const m = mode || getTheme()
  let dark = m === "dark"
  if (m === "system") {
    try {
      dark = matchMedia("(prefers-color-scheme: dark)").matches
    } catch (e) {}
  }
  document.documentElement.classList.toggle("dark", dark)
  return m
}

export function setTheme(mode) {
  try {
    localStorage.setItem(KEY, mode)
  } catch (e) {}
  return applyTheme(mode)
}

// Apply persisted theme on boot and keep "system" in sync with the OS.
export function initTheme() {
  applyTheme()
  try {
    matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
      if (getTheme() === "system") applyTheme("system")
    })
  } catch (e) {}
}
